PJQ.views.dailyReports.WorkLogManagement = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Work-Log-Management'),
        filters: {}
    },
    events: {
        'click .btn-filter': 'filterClicked',
        'click .btn-clear-filter': 'clearFilters',
        'click .btn-add-work-log': 'addClicked',
        'click .btn-carry-work-logs-all': 'carryOverWorkLogsAll',
        'click .btn-carry-work-logs-last': 'carryOverWorkLogsLast',
        'click .btn-delete-all-work-logs': 'deleteAllWorkLogs',
        'click .edit-work-log': 'editClicked',
        'click .delete-work-log': 'deleteClicked'
    },
    beforeFirstRender: function () {
        this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
            && this.options.project.hasPermission('dailyReports.isAdminWorkLogs');

        let fnRender = _.bind(function () {
            this.listenTo(this.collection, 'sync update reset', _.bind(function () {
                this.dataTable.refresh();
            }, this));

            this.render();
        }, this)

        if (this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS)) {
            this.options.project.fetchLocations(_.bind(function (locations) {
                this.locations = locations;
                fnRender();
            }, this));
        } else {
            fnRender();
        }
    },
    beforeRender: function () {
        this.options.isLocked = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DAILY_REPORT_IS_LOCKED_AFTER_SUBMIT) && this.options.dailyReport.get('status') === 1;
        this.options.canEdit = this.options.project.hasPermission('dailyReports.canAddWorkLogs') && !this.options.isLocked;
    },
    renderData: function () {
        return {
            project: this.options.project,
            canEdit: this.options.canEdit
        };
    },
    afterRender: function () {
        let enableLocations = this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS);
        if (this.locations == null && enableLocations) {
            return;
        }

        if (enableLocations) {
            this.locationFilterPicker = new PJQ.inputs.ProjectLocationPicker({
                el: this.$('.filter-location'),
                project: this.options.project,
                isMultiple: true,
                onChange: _.bind(function (value) {
                    this.options.filters.locations = value;
                    this.filterData();
                }, this)
            });
        }

        this.renderDataTable();
    },
    filterClicked: function () {
        this.$('.btn-filter').hide();
        this.$('.filter-outer').show();
    },
    clearFilters: function () {
        this.locationFilterPicker.setValue(null);
        this.$('.btn-filter').show();
        this.$('.filter-outer').hide();
        this.options.filters = {};
        this.filterData();
    },
    filterData: function () {
        let data;
        if (_.size(this.options.filters.locations) > 0) {
            data = _.filter(this.collection.models, function (model) {
                return _.contains(this.options.filters.locations, model.get('locationId'));
            }, this);
        } else {
            data = this.collection.models;
        }
        this.dataTable.resetData(data);
    },
    renderDataTable: function () {
        let columns = [
            {
                "data": "attachments",
                "title": "",
                "orderable": false,
                "searchable": false,
                "width": "50px",
                "render": function (data) {
                    let attachmentCount = _.size(data.models);
                    return '<div style="min-width:40px;"><span class="fal fa-paperclip mr-1 ' + (attachmentCount > 0 ? 'text-success' : 'text-muted') + '"></span><span class="' + (attachmentCount > 0 ? 'text-dark' : 'text-muted') + '">' + attachmentCount.toString() + '</span></div>';
                }
            },
            {
                "data": "attributes",
                "title": "Name",
                "searchable": false,
                "width": "200px",
                "render": function (data, type, row) {
                    if (row.workBy != null) {
                        return row.workBy.get('contactName') + ' (' + row.workBy.get('companyName') + ')';
                    }
                    return row.get('name');
                }
            },
            {"data": "attributes.quantity", "title": "Quantity", "searchable": false, "width": "120px"},
            {
                "data": "attributes.hours",
                "title": "Hours",
                "searchable": false,
                "width": "120px",
                "render": function (data) {
                    return data > 0 ? data / 100 : 0;
                }
            },
            {
                "data": "attributes.groups",
                "title": "Trades",
                "orderable": true,
                "render": _.bind(function (data, type, row) {
                    return _.map(_.sortBy(row.groups.models, function (group) {
                        return group.get('sortOrder');
                    }), function (group) {
                        return group.get('groupName');
                    }).join(', ');
                }, this)
            }
        ];

        if (!this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS)) {
            columns.push({"data": "attributes.description", "title": "Description"});
        } else {
            columns.push({
                "data": "attributes.locationId",
                "title": "Location",
                "orderable": true,
                "width": "200px",
                "render": _.bind(function (data, type, row) {
                    let location = this.locations.get(data);
                    return location ? this.locations.getFullName(location) : '';
                }, this)
            });
        }

        columns.push({
            "data": "",
            "title": "",
            "orderable": false,
            "searchable": false,
            resizable: false,
            "width": "100px",
            "render": _.bind(function () {
                let buttons;
                if (this.options.canEdit) {
                    buttons = '<button type="button" class="btn btn-info edit-work-log ht-30p wd-35p mr-1 fs-14"><span class="fal fa-pencil"></span></button>';
                } else {
                    buttons = '<button type="button" class="btn btn-info edit-work-log ht-30p wd-35p mr-1 fs-14"><span class="fal fa-search"></span></button>';
                }
                if (this.options.isAdmin && this.options.canEdit) {
                    buttons += '<button type="button" class="btn btn-danger delete-work-log ht-30p wd-35p fs-14"><span class="fal fa-trash"></span></button>';
                }
                return '<div class="text-align-right show-on-row-hover" style="width:80px;">' + buttons + '</div>';
            }, this)
        });

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: '.work-logs-data-table-container',
            data: this.collection.models,
            isHideSearch: true,
            rowId: 'cid',
            order: [1, 'asc'],
            language: {
                zeroRecords: this.options.canEdit ? 'Click "Add Work Log" to create a new work log' : 'No work logs were added for this day'
            },
            onRowDoubleClick: _.bind(function (row) {
                this.editWorkLog(row.data());
            }, this),
            contextMenuOptions: this.isLocked ? null : {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.editWorkLog(row.data());
                        }, this),
                        isShown: _.bind(function () {
                            return this.options.canEdit;
                        }, this)
                    },
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.editWorkLog(row.data());
                        }, this),
                        isShown: _.bind(function () {
                            return !this.options.canEdit;
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: _.bind(function () {
                            return this.options.isAdmin && this.options.canEdit;
                        }, this),
                        onClick: _.bind(function (row) {
                            this.deleteWorkLog(row);
                        }, this)
                    }
                ]
            },
            columns: columns
        });
    },
    addClicked: function () {
        let newWorkLog = new PJQ.models.dailyReports.WorkLog({
            dailyReportId: this.options.dailyReport.id,
            name: "",
            quantity: null,
            hours: null,
            description: ""
        });
        this.editWorkLog(newWorkLog);
    },
    carryOverWorkLogsAll: function () {
        new PJQ.views.BaseModal({
            header: 'Confirm Comment',
            body: '<div class="text-dark">Are you sure you want to carry over work logs from all previous days?</div>',
            okButtonText: 'Carry Over',
            onOk: _.bind(function () {
                new PJQ.ajax.Request({
                    endpoint: this.options.dailyReport.endpoint() + '/workLogs/copy'
                }).get().done(_.bind(function (workLogs) {
                    let carriedWorkLogs = new PJQ.collections.dailyReports.WorkLogs(workLogs);
                    this.dataTable.addRow(carriedWorkLogs.models);
                    this.collection.reset(carriedWorkLogs.models);
                }, this)).fail(_.bind(function (xhr, err, result) {
                    //todo: error
                }, this));
            }, this),
            isShowCancelButton: true,
            cancelButtonText: "Cancel"
        });
    },
    carryOverWorkLogsLast: function () {
        new PJQ.views.BaseModal({
            header: 'Confirm Comment',
            body: '<div class="text-dark">Are you sure you want to carry over work logs from the last work day?</div>',
            okButtonText: 'Carry Over',
            onOk: _.bind(function () {
                new PJQ.ajax.Request({
                    endpoint: this.options.dailyReport.endpoint() + '/workLogs/copy?lastWorkDay=true'
                }).get().done(_.bind(function (workLogs) {
                    let carriedWorkLogs = new PJQ.collections.dailyReports.WorkLogs(workLogs);
                    this.dataTable.addRow(carriedWorkLogs.models);
                    this.collection.reset(carriedWorkLogs.models);
                }, this)).fail(_.bind(function (xhr, err, result) {
                    //todo: error
                }, this));
            }, this),
            isShowCancelButton: true,
            cancelButtonText: "Cancel"
        });
    },
    deleteAllWorkLogs: function () {
        new PJQ.views.BaseModal({
            header: 'Confirm Deletion',
            body: '<div class="text-dark">Are you sure you want to delete all work logs for this day?</div>',
            okButtonText: 'Delete Work Logs',
            onOk: _.bind(function () {
                new PJQ.ajax.Request({
                    endpoint: this.options.dailyReport.endpoint() + '/workLogs'
                }).delete().done(_.bind(function () {
                    this.collection.reset(null);
                    this.render();
                }, this)).fail(_.bind(function (xhr, err, result) {
                    //todo: error
                }, this));
            }, this),
            isShowCancelButton: true,
            cancelButtonText: "Cancel"
        });
    },
    editClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr')),
            workLog = row.data();
        this.editWorkLog(workLog);
    },
    editWorkLog: function (workLog) {
        let isNew = workLog == null || workLog.isNew();
        new PJQ.views.dailyReports.EditWorkLogModal({
            model: workLog,
            project: this.options.project,
            isLocked: this.options.isLocked,
            onSave: _.bind(function (workLog) {
                if (isNew) {
                    this.dataTable.addRow(workLog);
                    this.collection.add(workLog);
                }
                this.dataTable.refresh();
            }, this),
            onClose: _.bind(function (workLog) {
                if (workLog.hasChanged()) {
                    workLog.fetch({
                        success: _.bind(function () {
                            this.dataTable.refresh();
                        }, this)
                    });
                }
            }, this),
            onDelete: _.bind(function (workLog) {
                if (workLog.id > 0) {
                    let row = this.dataTable.getRow(workLog.cid);
                    if (row != null) {
                        this.dataTable.removeRow(row);
                    }
                    this.collection.remove(workLog);
                    workLog.destroy();
                }
            }, this)
        });
    },
    deleteClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteWorkLog(row);
    },
    deleteWorkLog: function (row) {
        let workLog = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this work log?",
            onDelete: _.bind(function () {
                this.collection.remove(workLog);
                workLog.destroy();
                this.dataTable.removeRow(row);
            }, this)
        });
    }
});

PJQ.views.dailyReports.EditWorkLogModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Modal-Edit-Work-Log'),
        subTemplates: {
            workItem: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'work-log-work-item'),
        },
        maxWidth: 800
    },
    events: {
        'click .work-log-save': 'save',
        'click .work-log-close': 'close',
        'keydown .input-numeric': 'numbersOnly',
        'click .work-log-delete': 'onDelete',
        'click .btn-add-work-item': 'addWorkItem',
        'click .btn-delete-work-item': 'deleteWorkItem',
        'change .progress-slider': 'progressChanged',
    },
    beforeModalCreated: function () {
        this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
            && this.options.project.hasPermission('dailyReports.isAdminWorkLogs');
        this.options.canEdit = this.model.isNew() || (this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
            && this.options.project.hasPermission('dailyReports.canAddWorkLogs') && !this.options.isLocked);

        this.options.enableWorkItems = this.options.project.preferences.getPref(PJQ.constants.preferenceTypes.ENABLE_WORK_LOG_WORK_ITEMS);
        this.options.enableProgress = this.options.project.preferences.getPref(PJQ.constants.preferenceTypes.ENABLE_WORK_LOG_PROGRESS);
        this.options.workItemsLabel = this.options.project.preferences.getPref(PJQ.constants.preferenceTypes.WORK_LOG_WORK_ITEM_LABEL);
        this.options.workItemsSubText = this.options.project.preferences.getPref(PJQ.constants.preferenceTypes.WORK_LOG_WORK_ITEM_SUB_TEXT);
    },
    renderData: function () {
        return {
            model: this.model,
            options: this.options,
            enableProgress: this.options.enableProgress,
            project: this.options.project,
            isAdmin: this.options.isAdmin,
            canEdit: this.options.canEdit
        };
    },
    afterRender: function () {
        this.model.on('change', function () {
            this.calculateTotal();
        }, this);
        this.calculateTotal();

        new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.work-by'),
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            selectedContact: this.model.workBy,
            isReadOnly: !this.options.canEdit,
            isSingleChoice: true,
            addButton: this.$('.btn-edit-work-by'),
            onChange: _.bind(function (selectedContact) {
                this.model.workBy = selectedContact;
                this.model.set('name');
                this.model.isDirty = true;
                this.renderWorkBy();
            }, this)
        });
        this.renderWorkBy();

        if (this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS)) {
            new PJQ.inputs.ProjectLocationPicker({
                el: this.$('.select-location'),
                project: this.options.project,
                onChange: _.bind(function (value) {
                    this.model.set('locationId', value);
                }, this),
                defaultValue: this.model.get('locationId')
            });
        }

        new PJQ.views.groups.GroupsSelectInput({
            el: this.$('.work-log-groups'),
            isShowAddButton: false,
            addButton: this.$('.btn-edit-groups'),
            selectedGroups: this.model.groups.models,
            isReadOnly: !this.options.canEdit,
            onAfterSave: _.bind(function (selectedGroups) {
                this.model.groups.reset(selectedGroups);
                this.model.isDirty = true;
            }, this)
        });

        if (this.options.canEdit) {
            new PJQ.Binder(this.$el, this.model, {
                watchElements: [
                    'input',
                    'textarea'
                ]
            });
        }

        PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.work-log-hours'), 2);

        this.renderWorkItems();

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.work-log-file-upload'),
            collection: this.model.attachments,
            canUpload: this.options.canEdit,
            // includeProjectAttachments: true,
            canDelete: this.options.isAdmin && this.options.canEdit,
            previewImageDimension: 150,
            sortDirection: 'asc',
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.id > 0) {
                    attachment.set('isDeleted', true);
                } else {
                    attachment.destroy();
                }
                this.model.isDirty = true;
                callback();
            }, this)
        });

        if (this.options.enableProgress) {
            this.renderProgress();
        }
    },
    renderProgress: function () {
        this.progressSlider = this.$('.progress-slider').bootstrapSlider({
            handle: 'square'
        });

        this.$('.progress-slider').append($('<div>', {
            class: 'font-weight-light fs-14 bg-' + this.options.colorClass + ' text-' + (this.options.colorClass === 'warning' ? 'dark' : 'light')
        }).text(this.model.get('progress') + '%'));

        this.progressChanged();
    },
    progressChanged: function () {
        let percent = this.progressSlider.data('bootstrapSlider').getValue(),
            $slider = this.$('.slider-selection'),
            $text = this.$('.progress-percent');
        $text.text(percent + '%');
        $text.removeClass('text-danger').removeClass('text-warning').removeClass('text-success');
        $slider.removeClass('slider-bg-danger bg-danger').removeClass('slider-bg-warning bg-warning')
            .removeClass('slider-bg-success bg-success');
        if (percent < 60) {
            $text.addClass('text-danger');
            $slider.addClass('slider-bg-danger bg-danger');
        } else if (percent >= 60 && percent < 100) {
            $text.addClass('text-warning');
            $slider.addClass('slider-bg-warning bg-warning');
        } else {
            $text.addClass('text-success');
            $slider.addClass('slider-bg-success bg-success');
        }
        if (this.model.get('progress') !== percent) {
            this.model.set('progress', percent);
        }
    },
    addWorkItem: function () {
        let workItem = new PJQ.models.dailyReports.WorkLogWorkItem({
            workLogId: this.model.id
        });
        this.model.workItems.add(workItem);
        this.renderWorkItem(workItem);
    },
    deleteWorkItem: function (e) {
        let $workItem = $(e.currentTarget).closest('.work-item'),
            workItemId = $workItem.data('cid'),
            workItem = this.model.workItems.get(workItemId);
        if (workItem != null) {
            if (workItem.id > 0) {
                workItem.set('delete', true);
            } else {
                this.model.workItems.remove(workItem);
            }
            $workItem.remove();
            this.model.isDirty = true;
        }
    },
    renderWorkItems: function () {
        _.each(this.model.workItems.models, (workItem) => {
            if (workItem.get('delete')) {
                return;
            }
            this.renderWorkItem(workItem);
        });

        new PJQ.Binder(this.$('.work-items'), this.model.workItems, {
            watchElements: [
                'input',
                'textarea'
            ],
            delegate: true,
            modelSelectorAttribute: 'data-cid',
            idAttribute: 'cid',
            modelSelector: '.work-item',
            afterChange: () => {
                this.model.isDirty = true;
            }
        });
    },
    renderWorkItem: function (workItem) {
        this.$('.no-work-items').remove();
        this.$('.work-items-header').removeClass('hidden');
        this.renderSubTemplate(true, this.options.subTemplates.workItem, this.$('.work-items'), {
            model: workItem,
            canEdit: this.options.canEdit
        }, () => {
        });
    },
    renderWorkBy: function () {
        let $contactSelect = this.$('.work-by'),
            $contactName = this.$('.work-log-name');
        if (this.model.workBy != null) {
            $contactName.addClass('hidden');
            $contactSelect.removeClass('hidden');
        } else {
            $contactSelect.addClass('hidden');
            $contactName.removeClass('hidden');
        }
    },
    numbersOnly: function (e) {
        return PJQ.helpers.inputHelpers.numbersOnly(e);
    },
    calculateTotal: function () {
        let hours = this.model.get('hours'),
            quantity = this.model.get('quantity'),
            overtimeHours = this.model.get('overtimeHours');
        this.$('.work-log-total').text((((hours ? hours : 0) * (quantity ? quantity : 0)) / 100) + ((overtimeHours ? overtimeHours : 0) / 100));
    },
    save: function () {
        if (this.fileUploader.isUploading()) {
            new PJQ.views.BaseModal({
                header: "Files Uploading",
                body: "You can't save while files are uploading"
            });
        } else {
            let cb = () => {
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
                this.removeModal();
            }
            if (this.model.hasChanged() || this.model.isNew()) {
                this.model.save(null, {
                    notify: true,
                    success: () => {
                        cb();
                    }
                });
                return;
            }
            cb();
        }
    },
    close: function () {
        if (this.options.canEdit && this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.onClose(this.model);
                    this.removeModal();
                }, this)
            });
        } else {
            this.onClose(this.model);
            this.removeModal();
        }
    },
    onDelete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this work log?",
            onDelete: _.bind(function () {
                if (this.options.onDelete) {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});
